<template>
    <div class="flex items-center gap-x-3 mt-1">
      <vs-button icon-pack="feather" icon="icon-trash" type="flat" @click="confirmDeleteRecord()" color="danger" />
      <vs-button v-if="hasInbox && $acl.check('admin')" icon-pack="feather" icon="icon-edit" type="flat" @click="openEdit()" color="warning" />
      <input
        ref="textLink"
        type="text"
        :value="'https://app.duotalk.io/invitation/' + inviteKey"
        class="hidden"
        v-if="inviteKey"
      />
      <vs-button v-if="inviteKey" icon-pack="feather" icon="icon-link" type="flat" @click="copyLink()"  />
    </div>
</template>

<script>
export default {
  data() {
    return {
      popupActive: false,
      acl: "",
      intentions: [],
      entities: [],
    };
  },
  name: "CellRendererActions",
  computed: {
    planData: function () {
      return this.$store.state.acc.current_acc.accPlan.plan.planParameters;
    },
    hasInbox: function () {
      return this.planData["inboxAvailable"];
    },
    inviteKey() {
      return this.params.data.inviteKey;
    },
  },
  methods: {
    openEdit() {
      this.params.context.componentParent.openEdit(this.params.data);
    },
    copyLink() {
      var copyText = this.$refs.textLink;

      copyText.select();
      copyText.setSelectionRange(0, 99999);

      navigator.clipboard.writeText(copyText.value);

      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("CopiedToClipboard"),
        color: "success",
        iconPack: "feather",
        position: "top-right",
        icon: "icon-check-circle",
        time: 4000,
      });
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("ConfirmRemoveUserAccess"),
        text: this.$t("ConfirmRemoveUserAccessMessage"),
        accept: this.deleteRecord,
        acceptText: this.$t("Delete"),
        cancelText: this.$t("Cancel"),
      });
    },
    deleteRecord() {
      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
        .dispatch("acc/removeAccAccess", {
          id: this.params.value,
          acc: this.$store.state.acc.current_acc.id,
        })
        .then(() => {
          this.showDeleteSuccess();
        })
        .catch((error) => {
          if (error.request != null)
            if (typeof error.request.response !== "undefined")
              error.message =
                JSON.parse(error.request.response).data != null
                  ? Array.isArray(JSON.parse(error.request.response).data)
                    ? JSON.parse(error.request.response).data[0].msg
                    : ""
                  : JSON.parse(error.request.response).message;
          this.$vs.notify({
            time: 2500,
            title: this.$t("Error"),
            text: error.message || this.$t("UnexpectedError"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },
    showDeleteSuccess() {
      this.$store
        .dispatch("acc/getAccUserList", this.$store.state.acc.current_acc.id)
        .then((response) => {
          this.$store.commit("acc/SET_CURRENT_ACC_USERS", response);
        });
      this.$vs.notify({
        color: "success",
        title: this.$t("Confirm"),
        text: this.$t("User") + " " + this.$t("DeletedSuccessfuly"),
        position: "top-right",
        time: 4000,
      });
    },
  },
  created() {
    this.acl = {
      label:
        this.params.data.acl.charAt(0).toUpperCase() +
        this.params.data.acl.slice(1),
      value: this.params.data.acl,
    };
  },
};
</script>
